import { TRACKING_PROVIDER } from "../providers";

import gtmAdapter from "./gtmAdapter";
import netcoreAdapter from "./netcoreAdapter";

/**
 * Provider Adapter Interface
 * - For every new pixel/analytic provider that we want to add support to our 'TrackingUtil', we need to create a new adapter file that contains the implementation for the functions listed in the below interface, then import the adapter object in this file.
 */
// const xxxxAdapter = {
//   isScriptExists: () => boolean,
//   hasInstance: () => boolean,
//   isInstanceExists: (providerApiKey) => boolean,
//   register: (providerApiKey) => void,
//   revokeConsent?: () => void,
//   grantConsent?: () => void,
//   pageViewSingle: (providerApiKey) => void,
//   pageView: () => void,
//   trackSingle: (providerApiKey, eventName, eventData) => void,
//   track: (eventName, eventData) => void,
//   activateDebugMode?: () => void,
//   appendUserAttributes?: (payload) => void,
//   identifyUser?: (userUniqueIdentifierValue) => void,
//   clearUser?: () => void,
// };
// export default xxxxAdapter;

const adapters = {
  [TRACKING_PROVIDER.GTM]: gtmAdapter,
  [TRACKING_PROVIDER.NETCORE]: netcoreAdapter,
};

export default adapters;
